import React, { useState, useEffect, useContext } from "react";
import Modal from "common/Modal";
import ActionsContext from "common/ActionsContext";

const getConflicts = (name) => {
  return ifCl.run(`show rule error ${name}`);
};

// Take the conflict of each error line, dropping the lines without one.
const parseConflicts = (response) =>
  response
    .trim()
    .split("\n")
    .map((line) => line.split("EALREADY: ")[1])
    .filter((conflict) => conflict !== undefined);

const ConflictsContent = ({ conflicts }) =>
  conflicts === undefined ? (
    <p>Loading...</p>
  ) : conflicts.length === 0 ? (
    <p>No Conflicts Found</p>
  ) : (
    <div className="col-lg-12 col-md-12 col-sm-12 col-xs-12 margin-b-10">
      {conflicts.map((conflict, index) => (
        <p key={index}>{conflict}</p>
      ))}
    </div>
  );

const ConflictsModal = () => {
  const [open, setOpen] = useState(false);
  const [conflicts, setConflicts] = useState();
  const actions = useContext(ActionsContext);

  useEffect(
    () =>
      actions.recv("open-conflict-modal", (name) => {
        setOpen(true);
        // Drop the conflicts of the previous opening, they may be gone by now.
        setConflicts(undefined);
        getConflicts(name).then(parseConflicts).then(setConflicts);
      }),
    []
  );

  if (open === false) {
    return null;
  }

  return (
    <Modal
      title="Rule Conflicts"
      large={true}
      content={() => <ConflictsContent conflicts={conflicts} />}
      closeLabel="CANCEL"
      onClose={() => setOpen(false)}
    />
  );
};

export default ConflictsModal;
